import styled, { css } from 'styled-components';

interface IMenuProps {
  active: boolean;
  scrool: number;
}

export const Container = styled.header`
  top: 0;
  background: transparent;
  z-index: 100;

  a {
    font-family: 'Poppins';
    text-decoration: none;
    :hover {
      color: initial;
    }
  }

  .logo img {
    width: 45px;
    height: 45px;
  }

  .text-logo {
    color: #202020;
  }

  .menu-fix {
    width: 100%;
    height: 76px;
    position: fixed;
    z-index: 1000;
    transition-duration: 0.3s;
    top: 0;

    border-radius: 0px 0px 16px 16px;
  }

  .shadow-menu-desk {
    box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.1);
  }

  img {
    transition: 0.3s;
    height: 30px;
  }

  @media screen and (min-width: 991px) {
    height: 130px;

    .menu-fix {
      height: 130px;
    }

    .logo img {
      width: 63px;
      height: 63px;
    }

    img {
      height: 50px;
    }
  }
`;

export const Menu = styled.div<IMenuProps>`
  > button {
    width: 25px;
    height: 25px;

    span {
      display: block;
      width: 100%;
      height: 2px;
      background-color: #202020;
      border-radius: 30px;
      transition-duration: 0.5s;

      :nth-child(2) {
        margin: 6px 0px;
      }

      ${(props) =>
        props.active &&
        css`
          :nth-child(1) {
            transform: rotate(225deg);
          }

          :nth-child(2) {
            opacity: 0;
            transform: rotate(225deg);
          }

          :nth-child(3) {
            transform: rotate(315deg);
            margin-top: -16px;
          }
        `}
    }
  }

  .menu-group {
    transition-duration: 0.3s;
    width: 100%;
    position: absolute;
    left: ${(props) => (props.active ? 0 : 1000)}px;
    background-color: #fff;
    min-height: calc(100vh - 65px);
    top: 65px;

    .menu {
      min-height: calc(100vh - 65px);

      .btn-menu {
        transition-duration: 0.3s;
        color: #4b4b4b;
        font-size: 22px;
        font-weight: 400;
        position: relative;
        -webkit-text-fill-color: #4b4b4b;
        -webkit-text-stroke-width: 1.2px;
        -webkit-text-stroke-color: transparent;

        :after {
          content: '';
          position: absolute;
          width: 35px;
          height: 4px;
          border-radius: 2px;
          bottom: 10px;
          transition-duration: 0.3s;
        }
      }

      .btn-menu,
      .intitute {
        font-size: 18px;
      }

      .btn-menu:hover,
      .btn-menu.active {
        color: #00a189;
        -webkit-text-stroke-color: #00a189;
        -webkit-text-fill-color: #00a189;
      }
    }

    .intitute {
      transition-duration: 0.3s;
      color: #4b4b4b;
      font-size: 22px;
      font-weight: 400;
      position: relative;
      -webkit-text-fill-color: #4b4b4b;
      -webkit-text-stroke-width: 1.2px;
      -webkit-text-stroke-color: transparent;

      img {
        width: 29px;
        margin-right: 5px;
      }
    }

    .intitute:hover {
      color: #db562b;
      -webkit-text-stroke-color: #db562b;
      -webkit-text-fill-color: #db562b;
    }
  }

  @media screen and (min-width: 991px) {
    .menu-group {
      width: auto;
      position: unset;
      background-color: transparent;
      min-height: unset;

      .menu {
        min-height: unset;

        .btn-menu:hover,
        .btn-menu.active {
          color: #00a189;
          -webkit-text-stroke-color: #00a189;

          :after {
            background-color: #00a189;
          }
        }
      }
    }
  }
`;
